import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Form from '../../../2_Molecules/Form/Form'
import Select from '../../../1_Atoms/Forms/Select/Select'
import { useForm } from '../../../../hooks/useForm'
import { languageController } from '../../../../controllers/language/languageController'
import Button from '../../../1_Atoms/Button/Button'
import { Svg } from '../../../1_Atoms/Svg/Svg'
import FormGroup from '../../../2_Molecules/FormGroup/FormGroup'
import parse from 'html-react-parser';
import { handleRequest } from '../../../../utils/httpRequest'
import { getEndpointUrl } from '../../../../utils/endPoints'
import generalController from '../../../../controllers/generalController'

function SelectVehicleStep_VA({
  introductionText,
  language,
  setCurrentStep,
  setAccessoriesData
}) {
  const [modelOptions, setModelOptions] = useState([]);
  const [trimOptions, setTrimOptions] = useState([]);
  const [vehicleData, setVehicleData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const province = generalController.getMetatagValue('province');
  const initState = {
    model: '',
    trim: '',
  }
  const validations = {
    model: ['required'],
    trim: ['required'],
  }

  useEffect(() => {
    async function fetchMazdaModels() {
      try {
        const res = await handleRequest('get', getEndpointUrl('model-years'));
        if (res.status === 200 && res.data) {
          const { model_years } = res.data;
          // Sort the model years alphabetically
          const sorted = model_years.sort((a, b) => a.carline.url_slug.localeCompare(b.carline.url_slug));
          setModelOptions(sorted.map(model => ({
            value: `${model.year.url_slug}|${model.carline.url_slug}`,
            label: model.title,
          })));
        } else {
          setErrorMessage(res.message)
        }
      } catch (err) {
        console.log(err)
      }
    }
    // Get the models list from the api.
    fetchMazdaModels();
  }, [])

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    onSubmit: async () => {
      try {
        const { modelCode, optionCode } = vehicleData;
        const endPoint = `${getEndpointUrl('model-accessories')}/${modelCode}/${optionCode}?prov_code=${province}&lang_code=${language}`;
        const res = await handleRequest('get', endPoint);

        if (res.status === 200 && res.data) {
          setAccessoriesData(res.data)
          setCurrentStep(2);
        } else {
          setErrorMessage(res.message)
        }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const handleModelChange = async (e) => {
    const { value } = e.target;
    // Set the selected model name in state
    // and init "trim" state and "trimOptions" state.
    setTrimOptions([]);
    setData({ ...data, model: value, trim: '' });

    // Get trims data of the selected model
    try {
      const [year, model] = value.split('|');
      const endPoint = `${getEndpointUrl('model-trims')}/${year}/${model}?prov_code=${province}&lang_code=${language}`;
      const res = await handleRequest('get', endPoint);

      if (res.status === 200 && res.data) {
        const { trims } = res.data;
        setTrimOptions(trims.map(trim => {
          const { financial, trim_type } = trim;
          return {
            value: `${financial.based_on.model_code}|${financial.based_on.option_code}`,
            label: trim_type.name,
          }
        }));
      } else {
        setErrorMessage(res.message)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleTrimChange = (e) => {
    // Set the selected trim in state
    handleChange(e);
    // Set model code and option code in state.
    const { value } = e.target;
    const [modelCode, optionCode] = value.split('|');
    setVehicleData({
      modelCode,
      optionCode
    });
  }

  const { model, trim } = data;

  return (
    <div className="mz-va-select-vehicle-step">
      <div className="mz-container">
        <div className="grid-inner-content-wide mz-va-select-vehicle-step__top">
          <div className="mz-va-select-vehicle-step__intro-text">
            {parse(introductionText)}
          </div>
        </div>
        <div className="grid-inner-content mz-va-select-vehicle-step__form">
          <h3 className="mz-va-select-vehicle-step__form-title">{languageController.getCopy('vehicleAccessories', 'heading')}</h3>
          <Form
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            errorMessage={errorMessage}
          >
            <FormGroup md={2}>
              <Select
                name="model"
                label={languageController.getFormCopy('label', 'model')}
                placeholder={languageController.getFormCopy('placeholder', 'model')}
                value={model}
                isRequired={true}
                errorMessage={errors.model}
                onChange={handleModelChange}
                options={modelOptions}
                disabled={(!modelOptions.length > 0)}
              />
              <Select
                name="trim"
                label={languageController.getFormCopy('label', 'modelTrim')}
                placeholder={languageController.getFormCopy('placeholder', 'modelTrim')}
                value={trim}
                isRequired={true}
                errorMessage={errors.trim}
                onChange={handleTrimChange}
                options={trimOptions}
                disabled={(!trimOptions.length > 0)}
              />
            </FormGroup>
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={languageController.getCopy('vehicleAccessories', 'continue')}
              buttonIcon={<Svg type="chevron_small" size={0.8} colour="white" style={{ top: '1px' }} />}
              buttonIconPosition="right"
              disabled={(!model || !trim)}
            />
          </Form>
        </div>
      </div>
    </div>
  )
}

SelectVehicleStep_VA.propTypes = {
  introductionText: PropTypes.string,
  language: PropTypes.string.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  setAccessoriesData: PropTypes.func.isRequired
}

export default SelectVehicleStep_VA